import React from 'react';
import '../css/Imports.css';
import '../../../../core/components/core/ApplicationsProfiles/PermissionTreeview.css';

/**
 * Toggle switch reutilizável baseado no padrão form-check-input-switch.
 * @param {string}   id         - ID único do input
 * @param {boolean}  checked    - Estado do toggle
 * @param {boolean}  disabled   - Se está desabilitado
 * @param {Function} onChange   - Callback ao mudar
 * @param {string}   [label]    - Label exibida
 * @param {string}   [sublabel] - Sublabel (ex: "(obrigatório)")
 * @param {string}   [layout]   - 'vertical' ou 'inline'
 */
const ImportToggle = ({ id, checked, disabled, onChange, label, sublabel, layout = 'vertical' }) => {
  if (layout === 'inline') {
    return (
      <div className="import-toggle-inline">
        {label && (
          <span
            className={`import-toggle-inline-label${disabled ? ' disabled' : ''}`}
            onClick={() => { if (!disabled && onChange) onChange(); }}
          >
            {label}
          </span>
        )}
        <div className="import-toggle-switch-wrapper">
          <input
            type="checkbox"
            id={id}
            className="form-check-input-switch"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
          />
          <label htmlFor={id} />
        </div>
      </div>
    );
  }

  // layout === 'vertical'
  return (
    <div className="import-toggle-vertical">
      <div className="import-toggle-switch-wrapper">
        <input
          type="checkbox"
          id={id}
          className="form-check-input-switch"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <label htmlFor={id} />
      </div>
      {label && (
        <span className="import-toggle-vertical-label">
          {label}
          {sublabel && <span className="import-toggle-vertical-sublabel"> {sublabel}</span>}
        </span>
      )}
    </div>
  );
};

export default ImportToggle;
